import checkIfPotentiallyCircularRangesOverlap from "./checkIfPotentiallyCircularRangesOverlap";
export default function getYOffsetForPotentiallyCircularRange(range, YOffsetLevelsWithRanges, assignYOffsetToRange) {
  let yOffset = [];
  const openYOffsetFound = YOffsetLevelsWithRanges.some(
    function(rangesAlreadyAddedToYOffset, index) {
      const rangeBlocked = rangesAlreadyAddedToYOffset.some(
        function(comparisonRange) {
          return checkIfPotentiallyCircularRangesOverlap(
            range,
            comparisonRange
          );
        }
      );
      if (!rangeBlocked) {
        yOffset = index;
        if (assignYOffsetToRange) range.yOffset = index;
        rangesAlreadyAddedToYOffset.push(range);
        return true;
      }
      return false;
    }
  );
  if (!openYOffsetFound) {
    yOffset = YOffsetLevelsWithRanges.length;
    if (assignYOffsetToRange) range.yOffset = YOffsetLevelsWithRanges.length;
  }
  return yOffset;
}
